import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Message from 'components/Message';

import messages from '../ModifierGroupEditor.messages';
import ConfirmSaveModal from './ConfirmSaveModal';

export const EDIT_SHARED_GROUP_MODAL_NAME = 'EditSharedGroupModal';

const EditSharedGroupModal = ({ groupName, itemNames, onConfirmSave }) => {
  const intl = useIntl();

  return (
    <ConfirmSaveModal
      label={intl.formatMessage(messages.editSharedDialogLabel)}
      title={
        <Message
          message={messages.editSharedTitle}
          values={{ groupName, strong: chunks => <strong>{chunks}</strong> }}
        />
      }
      cancelLabel={messages.editSharedCancel}
      acceptLabel={messages.editSharedAction}
      onConfirmSave={onConfirmSave}>
      <Message
        message={messages.editSharedUsedIn}
        values={{ itemCount: itemNames.length, itemNames: intl.formatList(itemNames, { type: 'conjunction' }) }}
      />
    </ConfirmSaveModal>
  );
};

EditSharedGroupModal.propTypes = {
  groupName: PropTypes.string,
  itemNames: PropTypes.arrayOf(PropTypes.string),
  onConfirmSave: PropTypes.func,
};

EditSharedGroupModal.defaultProps = {
  groupName: '',
  itemNames: [],
};

export default EditSharedGroupModal;
